export const NOTIFICATION_CENTER_FILENAME = '消息精灵.exe';

export function getNotificationCenterDownloadUrl(origin = '') {
  const baseUrl = String(origin || '').trim().replace(/\/+$/, '');
  return `${baseUrl}/tongzhizhongxinEXE/${NOTIFICATION_CENTER_FILENAME}`;
}
